import { faClose } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '../../form/Button';

interface ModalHeaderProps {
    onClose: () => void;
    title: string;
    isLoading?: boolean;
}

export function ModalHeader({ onClose, title, isLoading }: ModalHeaderProps) {
    return (
        <>
            <IconButton
                className="absolute right-2 top-2 text-sm text-gray-500 hover:text-gray-700 disabled:pointer-events-none"
                icon={faClose}
                onClick={onClose}
                disabled={isLoading}
            />
            <h2 className="mb-4 text-center text-lg font-semibold text-gray-800">{title}</h2>
        </>
    );
}
